
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DetailAction } from "@/app/dynamic-components/details/dynamic-detail.model";
import { EventDictionary } from "@/app/events/event.dictionary";
import { DetailContext } from "@/app/contexts/detail.context";
import { ruleEngine } from "@/app/services/rule.engine";
import DossierActionConfirmDialog from "@/components/dossiers/details/DossierActionConfirmDialog.vue";

@Component({
  components: { DossierActionConfirmDialog },
})
export default class DossierDetailComponentActions extends Vue {
  securityMap: { [key: string]: { canShow: boolean; isEnabled: boolean } } = {};
  canSeeAnyActions = false;

  confirmDialogOpen = false;
  confirmDialogTitleKey = "";
  confirmDialogDescriptionKey = "";
  confirmDialogFallbackTitleKey = "";
  private pendingEvent: {
    eventName: string;
    rawMetadata: { [key: string]: unknown };
    resolvedMetadata: { [key: string]: unknown };
  } | null = null;

  @Prop({
    default: () => {
      return null;
    },
  })
  detailContext!: DetailContext;

  @Prop({ default: [] })
  actions!: DetailAction[];

  @Watch("detailContext", { immediate: true })
  onDetailContext(): void {
    this.actions.forEach((action) => {
      this.securityMap[action.id] = { canShow: false, isEnabled: false };
      if (
        action.enabled &&
        action.enabled !== "" &&
        (action.enabled === "true" ||
          ruleEngine.resolveRule(this.detailContext, action.enabled))
      ) {
        this.securityMap[action.id].isEnabled = true;
      }
      if (
        action.shown &&
        action.shown !== "" &&
        (action.shown === "true" ||
          ruleEngine.resolveRule(this.detailContext, action.shown))
      ) {
        this.securityMap[action.id].canShow = true;
      }
    });
    this.canSeeAnyActions = Object.values(this.securityMap).some(
      (value) => value.canShow
    );
  }

  fireEventFromAction(action: DetailAction): void {
    const eventName = action.event || action.id;
    const metadata = action.metadata || {};
    const resolvedMetadata = this.detailContext.resolvePlaceholders(metadata);

    if (metadata.popupConfirm === true) {
      const handler = EventDictionary[eventName];
      if (!handler) {
        console.warn(
          `[DossierDetailComponentActions] popupConfirm set but no EventDictionary entry for "${eventName}"`
        );
        return;
      }
      this.pendingEvent = {
        eventName,
        rawMetadata: metadata,
        resolvedMetadata,
      };
      this.confirmDialogTitleKey =
        typeof metadata.popupTitle === "string" ? metadata.popupTitle : "";
      this.confirmDialogDescriptionKey =
        typeof metadata.popupDescription === "string"
          ? metadata.popupDescription
          : "";
      this.confirmDialogFallbackTitleKey = action.name || "";
      this.confirmDialogOpen = true;
      return;
    }

    const handler = EventDictionary[eventName];
    if (handler) {
      handler.getCallBack(this.detailContext, resolvedMetadata, metadata);
    }
  }

  executePendingEvent(): void {
    const pending = this.pendingEvent;
    if (!pending) return;
    const handler = EventDictionary[pending.eventName];
    if (handler) {
      handler.getCallBack(
        this.detailContext,
        pending.resolvedMetadata,
        pending.rawMetadata
      );
    }
    this.pendingEvent = null;
  }

  clearPendingConfirm(): void {
    this.pendingEvent = null;
  }
}
